import { render, staticRenderFns } from "./messageCenter.vue?vue&type=template&id=05f27518&scoped=true"
import script from "./messageCenter.vue?vue&type=script&lang=js"
export * from "./messageCenter.vue?vue&type=script&lang=js"
import style0 from "./messageCenter.vue?vue&type=style&index=0&id=05f27518&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f27518",
  null
  
)

export default component.exports